import { render, staticRenderFns } from "./vipPage.vue?vue&type=template&id=03fdbe41&scoped=true"
import script from "./vipPage.vue?vue&type=script&lang=js"
export * from "./vipPage.vue?vue&type=script&lang=js"
import style0 from "./vipPage.vue?vue&type=style&index=0&id=03fdbe41&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fdbe41",
  null
  
)

export default component.exports